export default __webpack_public_path__ + "static/media/chris-photo.5f70e625.jpg";